import React from 'react'
import Select       from './select'

import { withRouter }   from 'react-router-dom'

export default withRouter class RoleFilter extends Select
  @defaultProps:
    placeholder:  'All Roles'
    label:        'Role'
    name:         'role'

  value: ->
    @props.location.state?.filters?.role or []
